<template>
  <v-menu
    v-model="date_menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    :disabled="readonly"
    min-width="290px"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        :value="formattedDate"
        outlined
        readonly
        :disabled="disabled"
        v-bind="attrs"
        :rules="rules"
        placeholder="Select a date"
        hide-details="auto"
        :label="label"
        class="hover-pointer"
        persistent-placeholder
        v-on="on"
        @click:append="date_menu = true"
      >
        <template
          v-if="$slots.label"
          #label
        >
          <slot name="label"></slot>
        </template>
        <template #append>
          <v-icon>{{ appendIcon }}</v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="computedValue"
      :min="min"
      :max="max"
      :show-current="min"
      @input="date_menu = false"
      @change="$emit('change', $event)"
    />
  </v-menu>
</template>

<script>
import moment from 'moment';
export default {
  name: 'McsDatePicker',

  components: {},

  props: {
    value: { type: String, default: '' },
    label: { type: String, default: '' },
    rules: { type: Array, default: () => {} },
    appendIcon: { type: String, default: 'mdi-menu-down' },
    useScheduleRange: { type: Boolean, default: false },
    min: { type: String, default: '' },
    max: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  },

  data() {
    return {
      date_menu: false
    };
  },

  computed: {
    formattedDate() {
      const date = this.computedValue;
      if (!date) {
        return '';
      }
      if (this.useScheduleRange) {
        return this.getScheduleRangeFormatted(date);
      }
      return this.$options.filters.regularDate(date);
    },
    computedValue: {
      get() {
        console.log(this.value);
        return this.value;
      },
      set(val) {
        if (val) {
          this.$emit('input', val);
        }
      }
    }
  },

  methods: {
    show() {
      this.date_menu = true;
    },

    // Previously reached through the snailblast mixin, which this was the last consumer of. The
    // mailing window a chosen drop date implies: a day either side of it, three days after.
    getScheduleRange(date) {
      if (!date) {
        return [];
      }
      return [moment(date).add(-1, 'days'), moment(date).add(3, 'days')];
    },

    getScheduleRangeFormatted(date) {
      const dates = this.getScheduleRange(date);
      if (dates.length !== 2) {
        return '';
      }
      return `${this.$options.filters.regularDateNoYear(
        dates[0]
      )} - ${this.$options.filters.regularDateNoYear(dates[1])}`;
    }
  }
};
</script>
